"use strict";

jQuery(document).ready(function ($) {
    // ELEMENTS EQUALIZE
    var windowMinWidth = 576;
    var elToMeasureTitle = $('.news-list__title');
    var elToMeasureExcerpt = $('.news-list__excerpt');
    var equalize = function equalize($jqueryElement) {
        var maxHeight = 0;
        if (window.innerWidth > windowMinWidth) {
            // reset
            $jqueryElement.each(function () {
                $jqueryElement.height('');
            }); // set heights

            $jqueryElement.each(function () {
                if ($(this).height() > maxHeight) {
                    maxHeight = $(this).height();
                }
            });
            $jqueryElement.height(maxHeight);
        } else {
            $jqueryElement.each(function () {
                $jqueryElement.height('');
            });
        }
    };

    window.onresize = function () {
        new equalize(elToMeasureTitle);
        new equalize(elToMeasureExcerpt);
    };

    window.onload = function () {
        new equalize(elToMeasureTitle);
        new equalize(elToMeasureExcerpt);
    };
});

//# sourceMappingURL=spzoz-news.min.js.map